import { apiPainelAdministrativo, apiCallCenter } from '@/plugins/axios'

export default {
  buscarDadosPainel(form) {
    return apiPainelAdministrativo().post('/relatorio?_method=GET', form)
  },
  getFilas() {
    return apiCallCenter().get('/queue/lazy')
  },
}
